export default function validate(values) {
  let errors = {};

  if (!values.password) {
    errors.password = 'El password es requerido'
  }
  else if (values.password.length < 6 ){
    errors.password = 'El password debe tener al menos 6 carácteres'
  }

  if (!values.rePassword) {
    errors.rePassword = 'El password es requerido'
  }
  else if (values.rePassword.length < 6 ){
    errors.rePassword = 'El password debe tener al menos 6 carácteres'
  }

  if (values.password !== values.rePassword) {
    errors.rePassword = 'Los passwords ingresados deben ser iguales'
  }

  return errors;
};